import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, productWeightUnitField } from './common/productFields';
import { wasteFields } from './common/wasteFields';
import { msg } from '@lingui/core/macro';

const productSoldQuantity: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Products sold: end of life',
    context: 'Total number of products sold',
  }),
  externalDescription: msg({
    message: 'Total number of products sold',
    context: 'Products sold',
  }),
};

export const wasteProductsMetadata = {
  displayName: msg({
    message: 'Sold products: Waste',
    context: 'Activity data schema name for waste products',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...wasteFields,
    product_weight_quantity: {
      displayName: msg({
        message: 'Product weight quantity',
        context: 'Weight of an individual unit of product.',
      }),
      externalDescription: msg({
        message: 'Weight of an individual unit of product.',
        context: 'Product weight quantity',
      }),
    },
    product_weight_unit: productWeightUnitField,
    products_sold_quantity: productSoldQuantity,
    // NOTE: quantity does not exist on the BAT but products_sold_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: productSoldQuantity,
    products_sold_unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
